export default __webpack_public_path__ + "static/media/020_start.hevc.2f316664.mp4";